import React from 'react';
import ReactDOM from 'react-dom/client';
import Theme from './Theme';
import SeminisOnion from './Pages';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Theme>
      <SeminisOnion />
    </Theme>
  </React.StrictMode>
);
